var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnshelve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99967C18.3334 5.3973 14.6024 1.66634 10 1.66634C5.39765 1.66634 1.66669 5.3973 1.66669 9.99967C1.66669 14.602 5.39765 18.333 10 18.333C14.6024 18.333 18.3334 14.602 18.3334 9.99967Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5575 14.1665C5.915 14.1665 5.59167 14.9415 6.04417 15.3981L9.2575 18.6423C9.66667 19.0548 10.3333 19.0548 10.7425 18.6423L13.9558 15.3981C14.4083 14.9415 14.085 14.1665 13.4425 14.1665H6.5575Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 9.99986V16.499H11.6666V9.99986H8.33331Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.99984C11.6666 9.07936 10.9205 8.33317 9.99998 8.33317C9.07951 8.33317 8.33331 9.07936 8.33331 9.99984C8.33331 10.9203 9.07951 11.6665 9.99998 11.6665C10.9205 11.6665 11.6666 10.9203 11.6666 9.99984Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnshelve);
export default __webpack_public_path__ + "static/media/unshelve.ee2071c98fc4631d5a105dfc0fb6ecee.svg";
export { ForwardRef as ReactComponent };